module.exports = __webpack_public_path__ + "static/img/adv3.ca40a24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adv3.jpg
// module id = Oaa4
// module chunks = 1